import { useTranslation } from 'react-i18next';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';
import { SupplierEvaluationSnapshot } from '@/components/Approval/@components/SupplierEvaluation';
import { parseSupplierEvaluationContent } from '@/utils/approval/supplierEvaluation';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 127 GERP 협력사 평가 — 저장 본문 그대로(레거시 문서 포함). GERP 재조회 안 함 */
const SupplierEvaluationSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const content = parseSupplierEvaluationContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <InfoSectionTitle sx={{ mb: 1 }}>{t('업체성과평가')}</InfoSectionTitle>
      <SupplierEvaluationSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SupplierEvaluationSlot;
